import React, { useContext } from "react";
import './Orders.css';
import NavBar from "../Header/NavBar";
import { CartContext } from "../../context/CartContext";
import emptyOrder from '../../images/empty-order.png';

const Orders = () => {
    const { username } = useContext(CartContext);
    const ordersFromLocalStorage = JSON.parse(localStorage.getItem('orders'));

    return(
        <div className="orders-container-wrapper">
            <NavBar />
            <div className="orders-container">
                <div className="orders-main-container">
                    <div className="orders-account-wrapper">
                        <div className="orders-account">Account</div>
                        <div>{username}</div>
                    </div>
                    <div className="all-oreders-text">All Orders :</div>
                    {ordersFromLocalStorage ? <div>
                            {ordersFromLocalStorage.map((product, i) => {
                                return(
                                    <div className="orders-product" key={i}>
                                        <div className="orders-wrapper-item">
                                            <div className="orders-item-container">
                                                <div>
                                                    <img className="orders-item-image" src={product.searchImage} alt="product-img"/>
                                                </div>
                                                <div className="orders-item-details">
                                                    <div className="orders-item-brand">{product.brand}</div>
                                                    <div className="orders-item-info"><i>{product.product}</i></div>

                                                    <div className="product-details">
                                                        <span className="product-price">Rs.&nbsp;{product.price}&nbsp;</span>
                                                        <span className="product-mrp">Rs.&nbsp;{product.mrp}</span>
                                                        <br />
                                                        <span className="product-discount-percentage">{product.discountDisplayLabel}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        :<div className="empty-order-container">
                            <div className="empty-order-image-wrapper">
                                <img src={emptyOrder} className="empty-order-image" alt="empty-Order"/>
                            </div>
                            <div className="empty-order-text">You have not ordered anything yet.</div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
export default Orders;